import React from 'react';

import RemindersListModuleMC from '../../../modules/Reminders/RemindersListModuleMC';
import NavbarLayoutMC from '../../../layouts/NavbarLayoutMC';

const RemindersScreenMC = () => (
  <NavbarLayoutMC>
    <div className="container-fluid-no-padding px-30 py-20 w-100 bg-white store-content">
      <RemindersListModuleMC />
    </div>
  </NavbarLayoutMC>
);

export default RemindersScreenMC;
